export const GET_TRUSTED_ADDRESS = "GET_TRUSTED_ADDRESS";
export const ADD_TRUSTED_ADDRESS = "ADD_TRUSTED_ADDRESS";
export const REFETCH_TRUSTED_ADDRESS = "REFETCH_TRUSTED_ADDRESS";
export const DELETE_TRUSTED_ADDRESS = "DELETE_TRUSTED_ADDRESS";
export const POLL_TRUSTED_ADDRESS = "POLL_TRUSTED_ADDRESS";